import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-350ec5ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  key: 0,
  class: "footer xag-page__footer nongfu-button-wrap"
}

import { Button, Dialog } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { ref, withDefaults } from 'vue'
import { DevicePayInfoType, ApplyCommonInvoiceParams } from '@/types/insurance'
import { ConfirmUseStorageData } from '@/types/invoice'
import { showToastLoading, clearToast, showConfirmModal, showToastFail } from '@/utils/tools'
import AppHeader from '@/components/Header.vue'
import OrderApply from '@/components/invoice/order-apply.vue'
import DevicePayInfo from '../components/device-pay-info.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'apply-invoice-wrap',
  props: {
    detail: { default: () => null },
    guid: null,
    confirmHandle: null,
    isNotDetail: { type: Boolean, default: false }
  },
  emits: ['storageInit', 'applySuccess'],
  setup(__props: any, { emit: emits }) {

const props = __props as { detail: DevicePayInfoType | null, guid: string, confirmHandle: (guid: string, params: ApplyCommonInvoiceParams) => Promise<void>, isNotDetail: boolean };


const $route = useRoute()
const routeQuery = $route.query
const hasInvoiceInfo = ref(false)
const cacheKey = routeQuery.cacheKey as string
let invoiceInfo: ConfirmUseStorageData | null = null

const cacheDetailStoarageData: unknown | null = JSON.parse(sessionStorage.getItem(cacheKey))


async function submitInvoiceApply() {
  try {
    await showConfirmModal({
      message: '是否确认提交发票申请?',
      className: 'repair-dialog',
    })
    showToastLoading()
    const params = {
      invoice_guid: invoiceInfo.invoice.guid,
      invoice_type: '1',
    }
    await props.confirmHandle(props.guid, params)
    emits('applySuccess')
    clearToast()
  } catch (error) {
    console.log('error', error)
    if (error) {
      const message = error?.message || '申请失败'
      clearToast()
      Dialog.alert({
        title: '',
        message,
        confirmButtonColor: '#39b54a',
      }).then(() => {
        // on close
      })
    }
  }
}
async function initPageDetail() {
  if (!cacheDetailStoarageData) {
    return
  }
  emits('storageInit', cacheDetailStoarageData)
}
function invoiceInit(data: ConfirmUseStorageData) {
  invoiceInfo = data
  hasInvoiceInfo.value = !!invoiceInfo?.needInvoice
}

initPageDetail()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "发票申请" }),
    _createElementVNode("section", _hoisted_1, [
      _renderSlot(_ctx.$slots, "payInfo", {}, () => [
        _createVNode(DevicePayInfo, {
          detail: props.detail
        }, null, 8, ["detail"])
      ]),
      _createVNode(OrderApply, { onInvoiceInit: invoiceInit })
    ]),
    (props.detail || props.isNotDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Button), {
            class: "xa-vant-button",
            onClick: submitInvoiceApply,
            block: "",
            round: "",
            type: "success",
            disabled: !hasInvoiceInfo.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交发票申请")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})